import { Text } from "@dropbox/dig-components/typography";
import { Box, Stack } from "@dropbox/dig-foundations";
import {
  isAdminUser,
  useAccountIsDropboxer,
} from "@mirage/service-auth/useDropboxAccount";
import { useFeatureFlagValue } from "@mirage/service-experimentation/useFeatureFlagValue";
import { convertFeatureValueToBool } from "@mirage/service-experimentation/util";
import { useOnboardingValues } from "@mirage/service-onboarding/hooks";
import i18n from "@mirage/translations";
import React from "react";
import {
  AddAppsModuleItem,
  adminPrioritizedAppList,
  memberPrioritizedAppList,
} from "./AddAppsModuleItem";
import { CustomizeModuleItem } from "./CustomizeModuleItem";
import { GetStartedModuleItem } from "./GetStartedModuleItem";
import { PlatformModuleItem } from "./PlatformsModuleItem";

export const SetupModule: React.FC = () => {
  const { account } = useAccountIsDropboxer();
  const isAdmin = isAdminUser(account);

  const isEnabled = convertFeatureValueToBool(
    useFeatureFlagValue("dash_2025_04_01_setup_module_rollout"),
  );

  if (!isEnabled) {
    return null;
  }

  if (isAdmin) {
    return <AdminSetupModule />;
  }

  return <MemberSetupModule />;
};

const AdminSetupModule: React.FC = () => {
  const { onboardingValues } = useOnboardingValues();

  if (
    onboardingValues?.dismissedSetupModuleAddApps &&
    onboardingValues?.dismissedSetupModuleGetStarted &&
    onboardingValues?.dismissedSetupModulePlatforms &&
    onboardingValues?.dismissedSetupModuleCustomize
  ) {
    return null;
  }

  return (
    <div data-testid="setup-module-admin">
      <Box paddingLeft="Micro Medium" paddingBottom="Micro Large">
        <Text variant="label" isBold>
          {i18n.t("setup_module_title")}
        </Text>
      </Box>
      <Stack gap="12">
        <GetStartedModuleItem />
        <AddAppsModuleItem appList={adminPrioritizedAppList} />
        <PlatformModuleItem />
        <CustomizeModuleItem />
      </Stack>
    </div>
  );
};

const MemberSetupModule: React.FC = () => {
  const { onboardingValues } = useOnboardingValues();

  if (
    onboardingValues?.dismissedSetupModuleAddApps &&
    onboardingValues?.dismissedSetupModuleGetStarted &&
    onboardingValues?.dismissedSetupModulePlatforms
  ) {
    return null;
  }

  return (
    <div data-testid="setup-module-member">
      <Box paddingLeft="Micro Medium" paddingBottom="Micro Large">
        <Text variant="label" isBold>
          {i18n.t("setup_module_title")}
        </Text>
      </Box>
      <Stack gap="12">
        <GetStartedModuleItem />
        <AddAppsModuleItem appList={memberPrioritizedAppList} />
        <PlatformModuleItem />
      </Stack>
    </div>
  );
};

export default SetupModule;
